import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "@/styles/globals.css";
import { BrowserRouter } from "react-router-dom";
import store from "./redux/store.ts";
import { Provider } from "react-redux";
import { Toaster } from "@/components/ui/toaster.tsx";

// ... existing imports ...
import { monitoringService } from './services/monitoringService';

const { VITE_DEFAULT_DOMAIN, VITE_ENV, VITE_OPENOBSERVE_CLIENTID, VITE_OPENOBSERVE_ORGID } = import.meta.env;

// Initialize monitoring if in production
// if (VITE_ENV === "production" && VITE_OPENOBSERVE_CLIENTID && VITE_OPENOBSERVE_ORGID) {
//   monitoringService.initialize({
//     clientToken: VITE_OPENOBSERVE_CLIENTID,
//     applicationId: 'fitnfi-web-application-id',
//     site: VITE_DEFAULT_DOMAIN,
//     service: 'fitnfi-web-application',
//     env: 'production',
//     version: '0.0.1',
//     organizationIdentifier: VITE_OPENOBSERVE_ORGID,
//   });
// }

// ... rest of your React rendering code ...
ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
        <Toaster />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
